import '../../styles/DropDownModal.scss';

import React, { PureComponent } from 'react';
import { Input } from 'semantic-ui-react';
import { ValueChangedForFieldFunc } from '../../formeditor-types';
import { DropDownItem } from '../FormView/Fields/DropDownField';
import GfModal from '../../../gfcomponents/GfModal/GfModal';

export type DropDownModalProps = {
  value: string;
  dropdownItems: DropDownItem[];
  allowOther?: boolean;
  open?: boolean;
  onChanged: (value: string) => void;
  onClose: VoidFunction;
  valueUpdated: ValueChangedForFieldFunc;
};

export default class DropDownModal extends PureComponent<DropDownModalProps, TypeMePlease> {
  constructor(props) {
    super(props);

    this.handleDialogModalClose = this.handleDialogModalClose.bind(this);
    this.handleDropdownChanged = this.handleDropdownChanged.bind(this);
    this.handleSearchBoxChanged = this.handleSearchBoxChanged.bind(this);
    this.handleSearchBoxKeyUp = this.handleSearchBoxKeyUp.bind(this);
    this.handleDoneButtonClicked = this.handleDoneButtonClicked.bind(this);
    this.handleCancelButtonClicked = this.handleCancelButtonClicked.bind(this);
    this.handleClearButtonClicked = this.handleClearButtonClicked.bind(this);

    this.state = { searchQuery: this.props.value };
  }

  handleDialogModalClose() {
    this.props.onClose();
  }

  handleDropdownChanged(value) {
    this.props.onChanged(value);
    this.setState({ searchQuery: value });
  }

  handleSearchBoxChanged(event) {
    this.setState({
      searchQuery: event.target.value
    });
  }

  handleSearchBoxKeyUp(event) {
    if (event.key === 'Enter') {
      this.props.onChanged(this.state.searchQuery);
    }
  }

  handleDoneButtonClicked() {
    if (this.state.searchQuery) {
      this.props.onChanged(this.state.searchQuery);
    }
    this.props.onClose();
  }

  handleCancelButtonClicked() {
    this.props.onClose();
  }

  handleClearButtonClicked() {
    this.props.valueUpdated({ value: '' });
    this.setState({ searchQuery: '' });
    this.props.onClose();
  }

  render() {
    let itemList = null;
    let searchBox = null;

    if (this.props.allowOther) {
      searchBox = (
        <Input
          fluid
          placeholder="Enter Value"
          className="dropdown-field-input"
          onChange={this.handleSearchBoxChanged}
          onKeyUp={this.handleSearchBoxKeyUp}
          value={this.state.searchQuery}
        />
      );
    }

    if (this.props.dropdownItems) {
      itemList = this.props.dropdownItems.map((item) => (
        <li key={item.value} className={`item ${item.value === this.props.value ? 'selected' : ''}`}>
          <button onClick={() => this.handleDropdownChanged(item.value)} className="dropdown-field-item">
            {item.text}
          </button>
        </li>
      ));
    }

    return (
      <GfModal
        title="Select an item"
        className="dropdown-modal"
        scrolling
        open={this.props.open}
        primaryText={this.props.allowOther ? 'Done' : undefined}
        secondaryText="Clear"
        tertiaryText="Cancel"
        onPrimaryClick={this.handleDoneButtonClicked}
        onSecondaryClick={this.handleClearButtonClicked}
        onTertiaryClick={this.handleCancelButtonClicked}
        onClose={this.handleDialogModalClose}
        semanticUiModalProps={{ size: 'small', closeOnDimmerClick: true }}
      >
        {searchBox}
        <ul>{itemList}</ul>
      </GfModal>
    );
  }
}
